import { render, staticRenderFns } from "./ValidateDocuments.vue?vue&type=template&id=b3d38324&"
import script from "./ValidateDocuments.vue?vue&type=script&lang=js&"
export * from "./ValidateDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3d38324')) {
      api.createRecord('b3d38324', component.options)
    } else {
      api.reload('b3d38324', component.options)
    }
    module.hot.accept("./ValidateDocuments.vue?vue&type=template&id=b3d38324&", function () {
      api.rerender('b3d38324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/onboarding/views/ValidateDocuments.vue"
export default component.exports